import { render, staticRenderFns } from "./showIcon-editor.vue?vue&type=template&id=1c3c3552&scoped=true"
import script from "./showIcon-editor.vue?vue&type=script&lang=js"
export * from "./showIcon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c3552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3c3552')) {
      api.createRecord('1c3c3552', component.options)
    } else {
      api.reload('1c3c3552', component.options)
    }
    module.hot.accept("./showIcon-editor.vue?vue&type=template&id=1c3c3552&scoped=true", function () {
      api.rerender('1c3c3552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/showIcon-editor.vue"
export default component.exports